<!--
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-11-25 17:18:19
 * @LastEditors: Andy
 * @LastEditTime: 2023-01-09 00:10:34
-->
<template>
  <el-col tag="span" :lg="6" :md="8" :sm="8" :xl="6" :xs="12" class="x-filter-item search-form-item">
    <label class="x-filter-item-label" v-if="label">
      {{ label }}
    </label>
    <slot></slot>
  </el-col>
</template>

<script>
  export default {
    name: 'XFilterItem',
    props: {
      label: {
        type: String,
        default: ''
      },
      width: {
        type: Number,
        default: 80
      }
    }
  }
</script>

<style lang="scss">
  @media (min-width: 1920px) {
    // .x-filter-item {
    //   width: calc(100% / 5) !important;
    // }
  }

  .x-filter-item {
    display: flex;
    // align-items: column;
    flex-direction: column;
    // width: calc(100% / 4);
    margin-bottom: 16px;
    padding: 0;

    .x-filter-item-label {
      line-height: 30px;
      margin-right: 16px;
      white-space: nowrap;
    }

    .el-select,
    .el-input.el-input--medium {
      width: calc(100% - 36px);
    }
  }
</style>
